import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export interface ProBadgeProps {
  className?: string
}

/**
 * A small overlay badge indicating a feature requires a Pro subscription.
 * Designed to be positioned as a superscript indicator on buttons or labels.
 * Requires parent element to have relative positioning.
 */
export const ProBadge = ({ className }: ProBadgeProps): ReactNode => (
  <Badge
    variant="outline"
    className={cn(
      'pro-badge absolute -top-1 -right-2 px-1 py-0 text-[10px] leading-tight',
      'bg-green-100 text-green-700 border-green-300',
      'dark:bg-green-900/30 dark:text-green-400 dark:border-green-700',
      className
    )}
  >
    Pro
  </Badge>
)

ProBadge.displayName = 'ProBadge'
